import * as React from 'react';
import { useSelector } from '../../state';
import { type Person, selectors } from '../../state/editor';
import { nameFallback } from '../../utils';

function ceoProse(person?: Person) {
  if (person) {
    return (
      <p>
        <strong>{nameFallback(person.name)}</strong> er daglig leder og
        ansvarlig for daglig drift av selskapet.
      </p>
    );
  } else {
    return <p>Det er ikke valgt noen daglig leder i selskapet</p>;
  }
}

export const CeoSummary: React.FC = () => {
  const ceo = useSelector(selectors.getCeo);
  return ceoProse(ceo);
};
